import ApiError from './ApiError';

export const HTTP_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8023' : '';
const API_BASE_URL = `/api`;

const COMMON_HEADERS : { [key: string]: string } = {
  'Content-Type': 'application/json'
}

export const SLUG_TOKEN = '%clientslug%';

// Codes the server's JWT strategy returns when the token itself is rejected
// (bad signature, expired, unknown user). Other 401s (e.g. 1029, missing role) keep the session.
const INVALID_TOKEN_CODES = ['1099', '1002'];

const endSessionIfTokenRejected = (status: number, code: unknown, sentToken: boolean) => {
  if (!sentToken || status !== 401 || typeof code !== 'string' || !INVALID_TOKEN_CODES.includes(code)) return;
  localStorage.removeItem('user');
  window.location.assign('/login');
}

export default class BaseService {

  static getFullPath(path: string) {
    return `${API_BASE_URL}${path}`;
  }

  static async request(path: string, method = 'GET', body: any = null, headers: any = {}, serializeBody = true) {
    
    const userInStorage = localStorage.getItem('user');
    const user = userInStorage ? JSON.parse(userInStorage) : null;
    
    const allHeaders = { ...COMMON_HEADERS, ...headers };
    
    if(user) {
      if(user.token) allHeaders.Authorization = `Bearer ${user.token}`;
      if(user.user) path = path.replace(new RegExp(SLUG_TOKEN, 'g'), user.user.slug);
    }
    
    if((allHeaders['Content-Type']||'').toLowerCase() === 'multipart/form-data') delete allHeaders['Content-Type']; 
    
    var response = await fetch(`${API_BASE_URL}${path}`, {
      method,
      body: body ? (serializeBody ? JSON.stringify(body) : body) : undefined,
      headers: allHeaders
    });

    var result = null;

    var ctHeaders = response.headers.get('content-type');
    var cdHeaders = response.headers.get('content-disposition');
    if(ctHeaders && ctHeaders.indexOf('application/json') >= 0) result = await response.json();
    else if(cdHeaders && cdHeaders.indexOf('attachment') >= 0) result = await response.blob();
    else result = await response.text();

    if(!response.ok) {
      const respError = result.error||{};
      endSessionIfTokenRejected(response.status, respError.code, !!allHeaders.Authorization);
      const err = new ApiError(respError.message||'Ocurrió un error desconocido', respError);
      throw err;
    }

    return result;
  }

  static async download(path: string, method = 'GET', body = null, headers = {}, serializeBody = true) {
    const user = JSON.parse(localStorage.getItem('user')||"null");
    const allHeaders : { [key: string]: string } = { ...COMMON_HEADERS, ...headers };

    if(user) {
      if(user.token) allHeaders.Authorization = `Bearer ${user.token}`;
      if(user.user) path = path.replace(new RegExp(SLUG_TOKEN, 'g'), user.user.slug);
    }
    
    var response = await fetch(`${API_BASE_URL}${path}`, {
      method,
      body: body ? (serializeBody ? JSON.stringify(body) : body) : undefined,
      headers: allHeaders
    });

    let result;

    if(!response.ok) {
      result = await response.json();
      const respError = result.error||{};
      endSessionIfTokenRejected(response.status, respError.code, !!allHeaders.Authorization);
      const err = new ApiError(respError.message||'Ocurrió un error desconocido', respError);
      throw err;
    }
    else {
      result = await response.blob();
    }

    return result;
  }
}